import React, { useEffect, useState } from 'react';

type Props = {
	// handleSubmit: Function;
	// WorkflowData: any;
	// colorMode: string;
	// token: any;
	// botId: any;
	// tenantId: any;
	// conversationId: any;
	// cssPtag?: any;
	// addUserResponse: Function;
	// currentWorkflow: string;
	// changeScreen?: Function;
	// showToaster?: Function;
	// disableMandatory?: Function;
	// shouldDisableActions?;
	images;
	title?;
	isReason?;
	ffstore?;
};

const ImageDisplay = ({ images, title, isReason, ffstore }: Props) => {
	const [selectedImage, setImage] = useState(0);
	return (
		<div className='ff-product-image'>
			<div className='ff-product-preview'>
				<img src={images} />

				{/* {ffstore ?
					<img src={images} />
					:
					<img src={images[selectedImage] && images[selectedImage].src} />
				} */}
			</div>
			{/* {!ffstore && images.length > 1 &&
				<div className='ff-product-image-array'>
					{
						images.map((item, index) => {
							return (
								<div className={`ff-product-image-item ${selectedImage == index ? 'active' : ''}`} onClick={() => { setImage(index) }}>
									<img src={item.src} />
								</div>
							)

						})

					}
				</div>
			} */}
			{/* {isReason &&
				<div style={{ fontSize: '16px', fontWeight: 'bold' }}>{title}</div>
			} */}
		</div>
	);
};

export default ImageDisplay;
